module.exports = __webpack_public_path__ + "static/media/united-card-480p.2d0985ba.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/united-card-480p.mov
// module id = 509
// module chunks = 0